import React from 'react';
import TableRef from './TableRef';

class ForeignKeyRenderer {
  constructor(userInteraction, usedAliases) {
    this.userInteraction = userInteraction;
    this.usedAliases = usedAliases;
  }

  textAlignCenter() {
    return false;
  }

  keys() {
    return Object.keys(this.usedAliases).reverse();
  }

  valueToKeyMapper(fk) {
    return fk.localColumn().alias();
  }

  valueSortFunc(a, b) {
    return a
      .foreignColumn()
      .tov()
      .name()
      .localeCompare(b.foreignColumn().tov().name());
  }

  optionClicked(fk) {
    const props = { section: 'selectJoin', fk };
    return this.userInteraction(props);
  }

  renderKey(alias) {
    const tov = this.usedAliases[alias];
    return `${tov.name()} ${alias}`;
  }

  renderValue(fk, removeHighlight) {
    let schema = null;
    const tov = fk.foreignColumn().tov();
    if (tov instanceof TableRef) {
      if (tov.schema() !== 'public') {
        schema = <span className="faint">{tov.schema()}</span>;
      }
    }
    return (
      <span>
        <span className={removeHighlight ? '' : 'highlight'}>
          {fk.foreignColumn().tov().name()}{' '}
        </span>
        (on {fk.foreignColumn().name()} = {fk.localColumn().toString()}){' '}
        {schema}
      </span>
    );
  }
}

export default ForeignKeyRenderer;
